import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Building2, ShieldCheck, FileDown } from "lucide-react";
import { sr } from "../../lib/sr";
import PerformanceDashboard from "../../components/smartreach/PerformanceDashboard";
import "../../pages/smartreach/marketing.css";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ClientDashboard() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [range, setRange] = useState("30");

  useEffect(() => {
    let alive = true;
    sr.publicClientDashboard(token, range !== "30" ? range : null)
      .then((d) => { if (alive) setData(d); })
      .catch(() => { if (alive) setData({ error: true }); });
    return () => { alive = false; };
  }, [token, range]);

  if (!data) return <div className="sr-root" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}><Loader2 className="sr-spin" size={28} /></div>;
  if (data.error) {
    return (
      <div className="sr-root" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }} data-testid="client-dashboard-error">
        <div className="sr-card" style={{ maxWidth: 420, textAlign: "center" }}>
          <h2 style={{ fontSize: 20, color: "var(--navy)" }}>Dashboard unavailable</h2>
          <p className="sr-muted" style={{ marginTop: 8 }}>This dashboard link is invalid or has been revoked. Please ask your agency for a new link.</p>
        </div>
      </div>
    );
  }

  const ag = data.agency || {};
  const a = data.analytics || {};
  const biz = a.business || {};
  const accent = ag.accent_color || "#2563EB";
  const pdfUrl = `${BACKEND}/api/public/agency/client/${token}/report.pdf${range !== "30" ? `?range=${range}` : ""}`;

  return (
    <div className="sr-root" style={{ minHeight: "100vh", background: "#F2F4F2" }} data-testid="client-dashboard">
      {/* White-labeled agency header */}
      <header style={{ background: "#fff", borderBottom: "1px solid #E4E8E6", padding: "16px 20px", position: "sticky", top: 0, zIndex: 10 }}>
        <div style={{ maxWidth: 980, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {ag.logo_url
              ? <img src={ag.logo_url} alt={ag.name || "Agency"} style={{ height: 40, maxWidth: 180, objectFit: "contain" }} data-testid="client-agency-logo" />
              : <div style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 800, color: "var(--navy)", fontSize: 20 }} data-testid="client-agency-name"><Building2 size={22} /> {ag.name || "Agency"}</div>}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <a className="sr-btn sr-btn-ghost sr-btn-sm" href={pdfUrl} target="_blank" rel="noreferrer" data-testid="client-download-pdf"><FileDown size={14} /> Download PDF</a>
            <span className="sr-badge" style={{ background: accent, color: "#fff" }}><ShieldCheck size={12} /> Live performance</span>
          </div>
        </div>
      </header>

      <main style={{ maxWidth: 980, margin: "0 auto", padding: "28px 20px 64px" }}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 13, color: "#5b6b85", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".05em" }}>Performance dashboard</div>
          <h1 style={{ fontSize: 30, color: "var(--navy)", marginTop: 4 }}>{biz.name}</h1>
          {(biz.category || biz.locations) && (
            <p className="sr-muted" style={{ marginTop: 4 }}>
              {biz.category}{biz.category && biz.locations ? " · " : ""}{biz.locations ? `${biz.locations} location${biz.locations > 1 ? "s" : ""}` : ""}
            </p>
          )}
        </div>

        <PerformanceDashboard analytics={a} accent={accent} range={range} onRangeChange={setRange} />

        <p style={{ textAlign: "center", marginTop: 40, fontSize: 12, color: "#8496A8" }}>
          Prepared by {ag.name || "your agency"} · Powered by SmartReachAI
        </p>
      </main>
    </div>
  );
}
